// extracted by mini-css-extract-plugin
export default {"header":"reports_header__Vsh43","btnText":"reports_btnText__vGyo-","linkStyle":"reports_linkStyle__F+2yg","linkStyleNoPermission":"reports_linkStyleNoPermission__m0La8"};